<template>
  <div class="user-info container">
    <div class="user-info-inner">
      <div class="user-info-text">
        <p>
          <img src="@/assets/icon/edit.png" alt="" /> Хэрэглэгчийн мэдээлэл
          засах
        </p>
      </div>
      <div class="user-info-board">
        <form
          action=""
          class="user-edit-panel-profile-mobile"
          @submit.prevent="sendData"
        >
          <div class="form-group flex column">
            <label for="">Овог: </label>
            <div
              class="user-input"
              v-if="
                user.lastName == 'null' ||
                user.lastName == null ||
                user.lastName == ''
              "
            >
              <input type="text" class="form-control" v-model="lastname" />
            </div>
            <div class="user-input" v-else>
              <p class="user-static1">{{ user.lastName }}</p>
            </div>
          </div>
          <div class="form-group flex column">
            <label for="">Нэр: </label>
            <div
              class="user-input"
              v-if="
                user.firstName == 'null' ||
                user.firstName == null ||
                user.firstName == ''
              "
            >
              <input type="text" class="form-control" v-model="firstname" />
            </div>
            <div class="user-input" v-else>
              <p class="user-static1">{{ user.firstName }}</p>
            </div>
          </div>
          <div class="form-group flex column">
            <label for="">УТАСНЫ дУГААР: </label>
            <div class="user-input" style="display: flex; flex-direction: row">
              <p
                class="user-static"
                style="
                  background: #ebebeb;
                  height: 31px;
                  padding-top: 7px;
                  margin-right: 7px;
                "
              >
                {{ phone }}
              </p>
              <img
                src="@/assets/icon/edit-b.png"
                alt=""
                @click="idNumber()"
                class="static-image"
              />
              <p @click="idNumber()" class="static-text">өөрчлөх</p>
            </div>
          </div>
          <div class="form-group flex column">
            <label for="">РЕГИСТЕР: </label>
            <div
              class="user-input"
              style="flex-direction: row; display: flex"
              v-if="user.customerRegNo == null || user.customerRegNo == ''"
            >
              <select
                class="form-control"
                style="width: 25%; margin-right: 2%; padding: 0 !important"
                name="regFirst"
                v-model="regFirst"
              >
                <option
                  v-for="data in letters"
                  :value="data.value"
                  :key="data.value"
                >
                  {{ data.name }}
                </option>
              </select>
              <select
                class="form-control"
                style="width: 25%; margin-right: 2%; padding: 0 !important"
                name="regSecond"
                v-model="regSecond"
              >
                <option
                  v-for="data in letters"
                  :value="data.value"
                  :key="data.value"
                >
                  {{ data.name }}
                </option>
              </select>
              <input
                type="number"
                class="form-control col-md-6"
                style="margin-top: 0"
                v-model="regThird"
              />
            </div>
            <div class="user-input" v-else>
              <p class="user-static1">{{ user.customerRegNo }}</p>
            </div>
          </div>
          <div class="form-group flex column">
            <label for="">ХҮЙС: </label>
            <div class="user-input">
              <p class="user-static1">{{ gender }}</p>
            </div>
          </div>
          <div class="form-group flex column">
            <label for="">Гар утас:<span>*</span> </label>
            <div class="user-input">
              <input type="text" class="form-control" v-model="phone2" />
            </div>
          </div>
          <div class="form-group flex column">
            <label for="">Е-Баримт бүртгэлийн код:<span>*</span> </label>
            <div class="user-input column">
              <input
                type="number"
                class="form-control"
                v-model="ebarimt"
                @keyup="checkLength"
              />
              <p v-if="ebarimtError" class="ebarimt-error">
                8 оронтой тоогоо оруулна уу !
              </p>
            </div>
          </div>
          <div class="form-group flex column">
            <label for="">имэйл хаяг:<span>*</span> </label>
            <div class="user-input">
              <input type="text" class="form-control" v-model="email" />
            </div>
          </div>
          <div class="form-group flex column">
            <label for="">ХОТ/АЙМАГ:<span>*</span> </label>
            <div class="user-input">
              <select
                name=""
                class="form-control user-select"
                @change="change"
                v-model="city"
              >
                <option v-for="data in allCity" :value="data.id" :key="data.id">
                  {{ data.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="form-group flex column">
            <label for="">СУм/дүүрэг:<span>*</span> </label>
            <div class="user-input">
              <select name="" class="form-control user-select" v-model="dis">
                <option
                  v-for="data in allDisctrict"
                  :value="data.id"
                  :key="data.id"
                >
                  {{ data.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="form-group flex column">
            <label for="">БАГ/ХОРОО:<span>*</span> </label>
            <div class="user-input">
              <input
                type="text"
                class="form-control"
                v-model="bag"
                maxlength="3"
              />
              <p class="error" v-if="bagError">{{ bagErrorMessage }}</p>
            </div>
          </div>
          <div class="form-group flex column">
            <label for="">БАЙР/ГУДАМЖ:<span>*</span> </label>
            <div class="user-input">
              <input
                type="text"
                class="form-control"
                v-model="home"
                ref="uhome"
              />
            </div>
          </div>

          <div class="form-group">
            <input
              type="submit"
              class="btn user-btn"
              value="Хадгалах"
              :disabled="isDisabled"
            />
          </div>
        </form>
        <transition name="fade">
          <Success
            :successMessage="successMessage"
            v-if="successModal"
            @hideSuccessMessage="hideSuccessMessage"
          ></Success>
        </transition>
        <transition name="fade">
          <Error
            :errorMessage="errorMessage"
            v-if="errorModal"
            @hideErrorMessage="hideErrorMessage"
          ></Error>
        </transition>
        <transition name="fade">
          <Number
            @closeNumber="closeNumber"
            @setNumber="setNumber"
            v-if="checkNumber"
            :phone="user.idPhone"
          ></Number>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import Number from "./number/main";
import { MobileUserEdit } from "@/mixins/MobileUserEdit";
import Success from "@/views/plugin/success";
import Error from "@/views/plugin/error";
import EventBus from "@/EventBus.js";
import { User } from "@/mixins/User";
import letterJSON from "@/json/data.vue";
export default {
  mounted() {
    this.getuser();
  },
  mixins: [MobileUserEdit, User],
  data() {
    return {
      firstname: "",
      lastname: "",
      register: "",
      regFirst: null,
      regSecond: null,
      regThird: null,
      user: {},
      phone: "",
      phone2: "",
      email: "",
      city: "",
      dis: "",
      bag: "",
      home: "",
      ebarimt: "",
      successMessage: "",
      bagError: "",
      bagErrorMessage: "",
      allCity: [],
      allDisctrict: [],
      checkNumber: false,
      successModal: false,
      errorMessage: "",
      errorModal: false,
      isDisabled: false,
      ebarimtError: false,
      letters: letterJSON.myJson,
    };
  },
  computed: {
    gender() {
      if (this.user.customerGender === "M") {
        return "Эрэгтэй";
      } else if (this.user.customerGender === "F") {
        return "Эмэгтэй";
      } else {
        return "";
      }
    },
  },
  methods: {
    checkLength() {
      let a = this.ebarimt;
      if (a.length != 8) {
        if (a == 0) {
          this.ebarimtError = false;
        } else {
          this.ebarimtError = true;
        }
      } else {
        this.ebarimtError = false;
      }
    },
    RedirectLogin() {
      EventBus.$emit("GLOBAL_ERROR", "error");
    },
    setNumber(phoneNumber) {
      this.phone = phoneNumber;
    },
    hideSuccessMessage() {
      (this.successMessage = ""), (this.successModal = false);
    },
    // hide error message
    hideErrorMessage() {
      (this.errorMessage = ""), (this.errorModal = false);
    },
    hideMenu() {
      EventBus.$emit("MOBILE_MENU_HIDE");
    },
    successEdit() {
      this.successMessage = "Амжилттай хадгаллаа ";
      this.successModal = true;
    },
    getuser() {
      var tokenId = localStorage.getItem("authToken");
      var userOwnData = this.$auth.getMe();
      if (tokenId == null || userOwnData == null) {
        this.RedirectLogin();
        this.$auth.destroyToken();
        this.$auth.removeMe();
        this.$router.push({ name: "login" });
      }
      this.$bonusApi
        // this.$axiosApi
        .post(
          `bonus-card/info/token`,
          // `card/info`,
          { tokenId },
          {
            headers: {
              "Content-Type": "application/json",
              "Accept-Language": "mn",
            },
          }
        )
        .then((response) => {
          var result = response.data;
          if (result.status === 0) {
            this.user = result;
            this.phone = this.user.idPhone;
            this.phone2 = this.user.customerPhone;

            this.city = this.user.customerAddressCity;
            this.dis = this.user.customerAddressDistrict;

            this.email = this.user.customerEMail;

            this.ebarimt = this.user.vatCustomerNo;
            this.bag = this.user.customerAddressKhoroo;
            this.home = this.user.customerAddressHome;
            this.getDistrict(this.city);
          }
        })
        .catch((error) => {
          this.RedirectLogin();
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        });
    },
    sendData() {
      let ebarimt = this.ebarimt;
      var isnumebarimt = /^\d+$/.test(ebarimt);

      if (ebarimt == 0) {
        this.send();
      } else {
        if (String(ebarimt).length == 8 && isnumebarimt) {
          this.send();
        } else {
          this.ebarimtError = true;
        }
      }
    },
    send() {
      var userbag = this.bag;
      var isnum = /^\d+$/.test(userbag);
      if (isnum) {
        this.bagError = false;
        this.isDisabled = true;
        var firstName =
          this.user.firstName != null && this.user.firstName != ""
            ? this.user.firstName
            : this.firstname;
        var lastName =
          this.user.lastName != null && this.user.lastName != ""
            ? this.user.lastName
            : this.lastname;
        if (
          this.regFirst != null &&
          this.regSecond != null &&
          this.regThird != null
        ) {
          this.register = this.regFirst + this.regSecond + this.regThird;
        }
        var registerNo =
          this.user.customerRegNo != null && this.user.customerRegNo != ""
            ? this.user.customerRegNo
            : this.register;

        var phone = this.phone2;
        var email = this.email;
        var districtId = this.dis;
        var khorooNumber = this.bag;
        var homeAddress = this.home;
        let tokenId = localStorage.getItem("authToken");
        let userData = this.$auth.getMe();
        let vatCustomerNo = this.ebarimt;

        if (tokenId == null || userData == null) {
          this.RedirectLogin();
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        }
        let cardHolderInfId = userData.cardHolderInfId;

        this.$bonusApi
          .post(
            `bonus-card/update/holderMyInfo`,
            {
              tokenId,
              cardHolderInfId,
              phone,
              email,
              districtId,
              khorooNumber,
              homeAddress,
              vatCustomerNo,
              firstName,
              lastName,
              registerNo,
            },
            {
              headers: {
                "Content-Type": "application/json",
                "Accept-Language": "mn",
              },
            }
          )
          .then((response) => {
            if (response.data.status === 1) {
              this.successEdit();
            } else {
              this.errorMessage = response.data.message;
              this.errorModal = true;
            }
            this.isDisabled = false;
          })
          .catch((error) => {
            this.isDisabled = false;
            this.errorMessage =
              (error.response && error.response.data && error.response.data.message) ||
              "Мэдээлэл хадгалахад алдаа гарлаа.";
            this.errorModal = true;
          });
      } else {
        this.bagError = true;
        this.bagErrorMessage = "Та зөвхөн тоо оруулна уу ?";
      }
    },
    getCity() {
      let tokenId = localStorage.getItem("authToken");
      let userData = this.$auth.getMe();

      if (tokenId == null || userData == null) {
        this.RedirectLogin();
        this.$auth.destroyToken();
        this.$auth.removeMe();
        this.$router.push({ name: "login" });
      }
      let cardHolderInfId = userData.cardHolderInfId;
      let type = "City";
      let typeValue = 0;
      this.$axiosApi
        .post(`card/constant/data`, {
          tokenId,
          cardHolderInfId,
          type,
          typeValue,
        })
        .then((response) => {
          var result = response.data;
          if (result.status === 0) {
            this.allCity = result.data;
          }
        })
        .catch((error) => {
          this.RedirectLogin();
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        });
    },
    getDistrict(value) {
      let tokenId = localStorage.getItem("authToken");
      let userData = this.$auth.getMe();
      if (tokenId == null || userData == null) {
        this.RedirectLogin();
        this.$auth.destroyToken();
        this.$auth.removeMe();
        this.$router.push({ name: "login" });
      }
      let cardHolderInfId = userData.cardHolderInfId;
      let type = "District";

      let typeValue = value || this.city;
      this.$axiosApi
        .post(`card/constant/data`, {
          tokenId,
          cardHolderInfId,
          type,
          typeValue,
        })
        .then((response) => {
          var result = response.data;
          if (result.status === 0) {
            this.allDisctrict = result.data;
            this.dis = this.user.customerAddressDistrict;
          }
        })
        .catch((error) => {
          this.RedirectLogin();
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        });
    },
    change() {
      this.getDistrict(this.city);
    },
  },
  created() {
    this.hideMenu();
    this.getCity();
  },
  components: {
    Success,
    Error,
    Number,
  },
};
</script>

<style>
.content {
  background: #f2f2f2;
}

.user-info-inner {
  padding-top: 22px;
}
.user-info-text {
  margin: 0;
  padding: 0;
  width: 100;
  height: auto;
  text-align: center;
}
.user-info-text p {
  margin: 0;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  color: #1660ab;
}
.user-info-text p svg {
  width: 17px !important;
  height: 17px;
}
.user-info-board {
  margin-top: 17px;
  width: 100%;
  border-radius: 10px;
  box-shadow: 0px 5px 5px 0 rgba(0, 0, 0, 0.05);
  background-color: #fff;
}
.user-info-item {
  padding-left: 25px;
  padding-right: 30px;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #d8d8d8;
}
.user-info-item p {
  font-size: 13px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: left;
  color: #1660ab;
  text-transform: uppercase;
  margin: 0;
}
.user-info-name {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  padding-bottom: 30px;
}
.user-info-name p:nth-child(1),
.user-info-name p:nth-child(3),
.user-info-name p:nth-child(5),
.user-info-name p:nth-child(7) {
  width: 40%;
  font-size: 10px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: left;
  color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
}
.user-info-name p:nth-child(2),
.user-info-name p:nth-child(4),
.user-info-name p:nth-child(6),
.user-info-name p:nth-child(8) {
  width: 60%;
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.77;
  letter-spacing: normal;
  color: #000000;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.user-info-name p:nth-child(10) {
  width: 40%;
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.77;
  letter-spacing: normal;
  color: #000000;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.user-info-name p:nth-child(9) {
  width: 60%;
  font-size: 10px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: left;
  color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
}
.user-info-name p:nth-child(11) {
  font-size: 13px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.85;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
}

.user-edit-panel-profile-mobile {
  width: 100%;
  padding-bottom: 30px;
  display: flex;
  flex-direction: column;
}
.user-edit-panel-profile-mobile .form-group {
  margin-bottom: 0;
  display: flex;
  padding-left: 38px;
  padding-right: 38px;
  margin-top: 25px;
}
.user-edit-panel-profile-mobile .form-group label {
  flex: 1;
  font-size: 10px;
  margin-bottom: 0;
  text-transform: uppercase;
  display: flex;
  justify-content: flex-start;
}
.user-edit-panel-profile-mobile .form-group span {
  color: red;
}

.user-edit-panel-profile-mobile .form-group .user-input {
  flex: 2;
}
.user-edit-panel-profile-mobile .form-group .user-input input {
  border-radius: 0;
  margin-top: 10px;
  height: 51px;
  width: 100%;
  font-size: 10px;
  color: rgba(0, 0, 0, 0.8);
  background-color: #fbfbfb;
  border: 1px solid #ebebeb;
}
.user-edit-panel-profile-mobile .form-group .age {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  position: relative;
  justify-content: flex-start;
}
.user-edit-panel-profile-mobile .form-group .age label {
  display: flex;
  justify-content: flex-start;
}
.user-edit-panel-profile-mobile .form-group .user-age {
  width: 30% !important;
}
.checkmark {
  position: absolute;
  top: 4px;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #fff;
  border: 1px solid #1660ab;
  border-radius: 50%;
}
.user-edit-panel-profile-mobile .form-group .age label {
  position: relative;
  flex: 1;
  cursor: pointer;
}
.user-edit-panel-profile-mobile .form-group .age input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}
.user-edit-panel-profile-mobile .form-group .age:hover input ~ .checkmark {
  background-color: #fff;
}
.user-edit-panel-profile-mobile .form-group .age input:checked ~ .checkmark {
  background-color: #2196f3;
}
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.user-edit-panel-profile-mobile
  .form-group
  .age
  input:checked
  ~ .checkmark:after {
  display: block;
}
.user-edit-panel-profile-mobile .form-group .age .checkmark:after {
  top: 5px;
  left: 5px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: white;
}
.user-edit-panel-profile-mobile .form-group .age p {
  margin-left: 30px;
  margin-bottom: 0;
  margin-top: 7px;
  border-radius: 0;
  margin-top: 10px;
  height: 51px;
  width: 100%;
  font-size: 10px;
  color: rgba(0, 0, 0, 0.8);
  background-color: #fbfbfb;
  border: 1px solid #ebebeb;
}

.user-edit-panel-profile-mobile .user-btn {
  background: #1660ab;
  color: #fff;
  font-size: 14px;
  margin: auto;
}
.user-edit-panel-profile-mobile .user-select {
  margin-top: 10px;
  width: 100%;
  font-size: 10px;
  height: 51px;
  background-color: #fbfbfb;
  border: 1px solid #ebebeb;
}
.error,
.ebarimt-error {
  color: red;
  font-size: 10px;
}
.user-static {
  margin-bottom: 0;
  margin-top: 10px;
  color: rgba(0, 0, 0, 0.8) !important;
  font-size: 10px;
  padding: 0.375rem 0.75rem;
}
.user-static1 {
  margin-bottom: 0;
  margin-top: 10px;
  color: rgba(0, 0, 0, 0.8) !important;
  font-size: 10px;
  padding: 0.375rem 0;
}
.static-image {
  margin-top: 15px;
  width: 15px;
  height: 15px;
}
.static-text {
  margin-top: 15px;
  margin-left: 10px;
  font-size: 10px;
}
</style>
